import { SimpleTextParagraph } from 'app/src/shared/components/SimpleTextParagraph'
import { useTranslation } from 'react-i18next'

export function SimpleTextSection() {
  const { t } = useTranslation('userInfo', { keyPrefix: 'UserInfo.SimpleTextSection' })

  return <SimpleTextParagraph txt={t('Text')} />
}
